<template>
    <div>
        <button 
            v-if="appName == 'sat-edu'"
            class="btn rounded-10 bg-secondary-color text-white mb-2 w-100"
            type="submit"
        >
            {{ tra.book }}
        </button>
        
        <button 
            @click="$emit('update-compare-offer', true)"
            class="btn rounded-10 bg-main-color text-white mb-2 w-100"
            type="button"
        >
            {{ tra.compare_price_offer }}
        </button>
        
        <button 
            @click="$emit('invoice')" 
            class="w-100 btn rounded-10 bg-secondary-color text-white mb-2"
            type="button"
        >
            {{ tra.get_price_quote }}
        </button>
        
        <hr>
        
        <p>
            {{ tra.send_price_via_whatsapp }} 
            <button 
                class="rounded-10 bg-main-color text-white p-1"
                @click="$emit('invoice', { WASendOffer: true })"
                type="button"
            >
                {{ tra.click_here }}
            </button>
        </p>

        <hr v-if="isAdmin == '1' && appName == 'sat-edu'">

        <div v-if="isAdmin == '1' && appName == 'sat-edu'" class="row">
            <div class="col-md-6">
                <button 
                    v-if="isAdmin == '1'" 
                    @click="$emit('invoice')"
                    class="w-100 btn rounded-10 bg-secondary-color text-white mb-2"
                    type="button"
                >
                    {{ tra.price_quote }}
                </button>
            </div>
            <div class="col-md-6">
                <button 
                    v-if="isAdmin == '1'" 
                    type="button" 
                    data-toggle="modal"
                    data-target="#save-offer-file"
                    class="w-100 btn rounded-10 text-white bg-secondary-color mb-2"
                >
                    {{ tra.save_price_quote }}
                </button>
            </div>

            <div class="col-12">
                <button 
                    v-if="addNewStudentRequestObj" 
                    @click="$emit('save-new-student-offer')"
                    class="w-100 btn rounded-10 bg-main-color text-white mb-2"
                    type="button"
                >
                    {{ tra.save_request_for }} ({{ addNewStudentRequestObj['student_name'] || '' }})
                </button>
            </div>
        </div>

        <button 
            type="button" 
            v-if="isAdmin == '1' && requestId" 
            @click="$emit('submit-with-request-id')"
            class="btn rounded-10 bg-secondary-color text-white mb-2 w-100"
        >
            {{ tra.save_request_data }}
        </button>
    </div>
</template>

<script>
export default {
    name: 'ActionButtons',
    props: {
        appName: String,
        isAdmin: [String, Number],
        requestId: [String, Number],
        addNewStudentRequestObj: [Object, Boolean],
        tra: Object,
    },
    emits: [
        'invoice',
        'update-compare-offer',
        'save-new-student-offer',
        'submit-with-request-id',
    ],
};
</script>